import iconQuit from '@assets/images/static/icon-quit-bg.png';
import iconValid from '@assets/images/static/icon-valid-bg.png';
import iconWarning from '@assets/images/static/icon-warning.svg';
//import iconWarning from '@assets/images/static/point-dexclamation.svg';

import React from 'react';
import { styled } from 'styled-components';
import { SIcon } from '~/pages/components/styles/styles';

import { classic } from '~/themes';

type IProps = {
  children: React.ReactNode;
  submitted: boolean;
  status?: 'good' | 'wrong' | 'warning' | 'neutral';
  dragged?: boolean;
};

type TProps = IProps;

export function DragDropItem({ status, submitted, children, dragged }: TProps) {
  return (
    <Container $status={status} $submitted={submitted} $dragged={dragged}>
      {children}
      {submitted && status === 'good' && <SIcon src={iconValid} alt="" />}
      {submitted && status === 'wrong' && <SIcon src={iconQuit} alt="" />}
      {submitted && status === 'warning' && <SIcon src={iconWarning} alt="" />}
    </Container>
  );
}

const Container = styled.div<{
  $submitted: boolean;
  $dragged?: boolean;
  $status?: 'good' | 'wrong' | 'warning' | 'neutral';
}>`
  align-items: center;
  /* background-color: ${({ $submitted, $status }) => {
    if (!$submitted) {
      return 'gray';
    } else {
      if ($status === 'good') return 'green';
      if ($status === 'wrong') return 'red';
      if ($status === 'warning') return 'orange';
      return 'gray';
    }
  }}; */
  border: 1px solid ${classic.token?.colorWhite};
  border-radius: ${({ $dragged }) => ($dragged ? '15px' : '20px')};

  box-shadow:
    inset 0 3.6px 3.6px 0 rgba(255, 255, 255, 0.35),
    inset 0 -3.6px 3.6px 0 rgba(0, 0, 0, 0.4),
    0 4px 4px 0 rgba(0, 0, 0, 0.1);

  background-image: ${({ $submitted, $status }) => {
    if (!$submitted) {
      return 'linear-gradient(to bottom, #bbe6ef, #fff),linear-gradient(to bottom, #ccecf3, #ccecf3)';
    } else {
      if ($status === 'good')
        return 'linear-gradient(to bottom, #5ee49d, #14b15c)';
      if ($status === 'wrong')
        return 'linear-gradient(to bottom, #e06363, #dd4848)';
      if ($status === 'warning')
        return 'linear-gradient(to bottom, #da8960, #dd6848)';
      return 'linear-gradient(to bottom, #bbe6ef, #fff),linear-gradient(to bottom, #ccecf3, #ccecf3)';
    }
  }};

  color: ${({ $submitted, $status }) => {
    if (!$submitted) {
      return `${classic.token?.colorTextSecondary}`;
    } else {
      if ($status === 'good') return `${classic.token?.colorWhite}`;
      if ($status === 'wrong') return `${classic.token?.colorWhite}`;
      if ($status === 'warning') return `${classic.token?.colorWhite}`;
      return `${classic.token?.colorTextSecondary}`;
    }
  }};
  font-family: 'PT Sans', sans-serif !important;
  font-weight: 700;
  line-height: normal;
  font-size: ${({ $dragged }) => ($dragged ? '0.95rem' : '0.90rem')};
  display: flex;
  height: ${({ $dragged }) => ($dragged ? '95%' : '100%')};
  justify-content: center;
  padding: 10px;
  position: relative;
  pointer-events: ${({ $submitted }) => ($submitted ? 'none' : 'auto')};
  text-align: center;
  width: ${({ $dragged }) => ($dragged ? '95%' : '100%')};
  user-select: none;

  /* @media screen and (max-width: 415px) {
    height: 95px;
  }

  @media screen and (max-height: 600px) {
    height: 95px;
  } */
`;
